import Joi from '@hapi/joi'

export const divisionFilterSchema = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Please Select the Valid Group`,
        "any.required": `Group required`
    }),

    operationEntityID: Joi.number().invalid(0).required().label("operation Entity ID").messages({
        "any.invalid": `Please Select the Valid Estate`,
        "any.required": `Estate required`
    }),

}

export const divisionSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Group Name cannot have invalid characters`,
        "any.required": `Group Name characters`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Estate Name").messages({
        "any.invalid": `Estate Name cannot have invalid characters`,
        "any.required": `Estate Name characters`
    }),
    collectionCategoryID: Joi.number().invalid(0).required().label("Collection Catagory Type").messages({
        "any.invalid": `Collection Catagory Type cannot have invalid characters`,
        "any.required": `Collection Catagory Type characters`
    }),
    collectionPointCode: Joi.string().required().invalid("00").min(2).max(2).label("Division Code").regex(/^\w+(?:\s+\w+)*$/).messages({
        "string.empty": `Division Code required`,
        "string.pattern.base": `Division Code cannot have invalid characters`,
        "string.min": `Please enter {#limit} digit number`,
        "string.max": `Please enter {#limit} digit number`,
        "any.invalid": `Cannot have 00 as division code`
    }),
    collectionPointName: Joi.string().required().label("Division Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Division Name required`,
        "string.pattern.base": `Please enter valid division name`,
    }),
    collectionPointLocation: Joi.string().allow("", null).label("Division Location"),
    isActive: Joi.boolean().label("Active")
}